import React, { useEffect, useState } from "react";
import { Box, Grid, IconButton, Toolbar } from "@mui/material";
import { makeStyles } from "@mui/styles";
import Typography from "@mui/material/Typography";
import { PostAddOutlined } from "@mui/icons-material";
import PropTypes from "prop-types";
import { useNavigate, useLocation } from "react-router-dom";
import RouteConstants from "../../common/RouteConstants";
import SocialCommunityAppBar from "./SocialCommunityAppBar";
import SocialCommunityTabPanel from "./SocialCommunityTabPanel";
import SocialSearchBar from "./SocialSearchBar";
import Loader from "../../sharedComponents/Loader/Loader";
import useTelemetry from "../../utils/useTelemetry";
import clsx from "clsx";

const useStyles = makeStyles((theme) => ({
    content: {
        margin: theme.spacing(2),
        boxShadow: "0px 0px 5px 3px rgba(0,0,0,0.1)",
        backgroundColor: theme.palette.background.paper,
        zIndex: '2',
    },
    toolbar: {
        flex: 1,
        display: "flex",
        justifyContent: "space-between",
        alignItems: 'center',
        [theme.breakpoints.down("xs")]: {
            paddingLeft: 0,
            paddingRight: 0,
        },
    },
    button: {
        border: `1px solid ${theme.palette.mode === 'dark' ? theme.palette.secondary.main : theme.palette.primary.main}`,
        borderRadius: '4px',
        padding: '6px 8px',
        marginBottom: '10px',
        fontSize: '1rem',
        color: '#fff',
        background: theme.palette.mode === 'dark' ? theme.palette.secondary.main : theme.palette.primary.main,
        '&:hover': {
            color: '#fff',
            background: theme.palette.mode === 'dark' ? theme.palette.secondary.main : theme.palette.primary.main,
        },
        '&:focus': {
            color: '#fff',
            background: theme.palette.mode === 'dark' ? theme.palette.secondary.main : theme.palette.primary.main,
        },
        '& svg': {
            marginRight: '5px',
        },
    },
}));

const SocialCommunityContainer = (props) => {
    const classes = useStyles();
    const navigate = useNavigate();
    const location = useLocation();
    const [tabIndex, setTabIndex] = useState(0); // Initial tabIndex state
    const [isLoading, setIsLoading] = useState(false); // Initial isLoading state
    const { trackCustomEvents } = useTelemetry();
    const [searchedText, setSearchedText] = useState("");


    // Extract tabIndex from props.location.state or default to 0
    useEffect(() => {

        if (location.state && location.state.tabIndex) {
            setTabIndex(location.state.tabIndex);
        }
    }, [location.state]);


    const handleTabChange = (event, newValue) => {
        setTabIndex(newValue);
        trackCustomEvents("ClickEvent", { event: newValue === 0 ? "All Post" : newValue === 1 ? "Pending Review Posts" : "Returned Posts" });
    };

    const onPressCreatePost = () => {
        navigate(RouteConstants.CREATE_SOCIAL_POST, {
            replace: true,
            state: {
                postDetails: null,
                editPost: false,
            }
        });
        trackCustomEvents("ClickEvent", { event: "Create Social Post" });
    };

    const handleSearch = (text) => {
        setSearchedText(text);
    };

    return (
        <div className={clsx(classes.content, "custom-view")}>
            <SocialCommunityAppBar tabIndex={tabIndex} handleTabChange={handleTabChange} />
            <Toolbar className={classes.toolbar}>
                <Typography variant="subtitle1" color="secondary">
                    NBA Coaches Database - Coaches Community
                </Typography>
                <IconButton onClick={onPressCreatePost} className={classes.button}>
                    <PostAddOutlined className={classes.cursorPointer} />
                    Create Post
                </IconButton>
            </Toolbar>
            <Grid container sx={{justifyContent: "center"}}>
                <Grid size={{ xs: 12, md: 8, lg: 6 }} sx={{ justifyContent: "center", alignItems: 'center', px: 4,paddingBottom: 2 ,width: '100%'}}>
                    <SocialSearchBar onSearch={handleSearch} tabIndex={tabIndex} />
                </Grid>
            </Grid>
            <Grid container justifyContent="center" sx={{ width: '100%' ,height: '100%'}}>
                <SocialCommunityTabPanel tabIndex={tabIndex} handleTabChange={handleTabChange} searchedText={searchedText} setIsLoading={setIsLoading} />
            </Grid>
            <Loader isLoading={isLoading} />
        </div>
    );
};

export default SocialCommunityContainer;
